var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"pagemargin page",attrs:{"justify-center":""}},[_c('v-flex',[(_vm.activeAdmin !== null)?_c('vsettings',{attrs:{"settings":_vm.component,"schema":_vm.settings}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }